<template>
  <b-card>
    <!-- <h4 class="p-2">Stats</h4> -->
    <div class="m-1 vars-chart">
      All project plan
      <b-form-group v-if="!isTv">
        <b-form-checkbox inline v-model="groupActive">Group active</b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="!isTv">
        <b-form-checkbox inline v-model="addPlannedWork">Add planned by person</b-form-checkbox>
      </b-form-group>
      <b-form-group v-if="!isTv">
        <b-form-checkbox inline v-model="withVacationsValue">Resources with vacations</b-form-checkbox>
      </b-form-group>

      <b-form-group label="Months ahead" v-if="!isTv">
        <b-form-input v-model="monthsAhead" placeholder="Enter your name"></b-form-input>
      </b-form-group>
    </div>
    <div v-if="spinners.contentIsLoading" class="text-center">
      <b-spinner type="grow" variant="primary" />
    </div>
    <div v-else class="chart-body with-heading">
      <!-- <v-gantt style="height: 400px;" :data.sync="ganttElem" /> -->
      <!-- <gantt :series="ganttElem"/> -->
      <!-- <apexchart width="100%" :height="chartHeight" type="rangeBar" :options="chartOptions" :series="ganttSeries"></apexchart> -->
      <apexchart width="100%" height="100%" type="line" :options="chartConfig" :series="weekLoad"></apexchart>
      <!-- <div>MAX: {{maxDate}}</div>
        <div>{{weekLoad}}</div> -->
    </div>
  </b-card>
</template>

<script>
// import statuses from '../../../store/statuses';
import { mapGetters, mapActions } from 'vuex';
// import Pagination from 'laravel-vue-pagination';
// import clone from 'lodash.clonedeep';
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import Services from '@/services';
// import vGantt from '@femessage/v-gantt';
// import gantt from '@/views/components/dash/Gantt';
// const monthsAhead = 12; //aprox
const colorArray = ['#FF6633', '#FFB399', '#FF33FF', '#00B3E6',
  '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
  '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
  '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
  '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
  '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
  '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
  '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
  '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
  '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF', '#FFFF99'];

export default {
  mounted() {
    this.getData();
  },
  props: {
    withVacations: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      monthsAhead: 6,
      spinners: {
        contentIsLoading: true,
      },
      groupActive: false,
      addPlannedWork: true,
      withVacationsValue: this.withVacations,
      issues: [],
      project: [],
      vacations: [],
      plannableUsers: [],
      plannedWork: [],

      chartOptionsArea: {
        chart: {
          animations: { enabled: false },
          stacked: true,
          zoom: {
            type: 'x',
            enabled: true,
            // autoScaleYaxis: true,
            autoScaleYaxis: false,
          },
          toolbar: { autoSelected: 'zoom' }
        },

        fill: {
          // type: 'gradient',
          opacity: 0.6,
          // opacityFrom: 0.7,
          // opacityTo: 0.9,
        },
        stroke: { width: 1 },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return val > 0 ? val : '';
          },
        },
        plotOptions: {
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {},
      },
    };
  },
  components: {
    // Pagination,
    // 'v-gantt':vGantt,
    // gantt,
    apexchart: VueApexCharts,
  },
  computed: {
    ...mapGetters('Auth', ['isTv']),
    chartConfig() {
      const chartOptionsArea = { ...this.chartOptionsArea };
      chartOptionsArea.dataLabels.enabledOnSeries = this.issuesByProject.map((v, i) => i);// hide available load data labels
      chartOptionsArea.stroke.width = [...this.issuesByProject.map((v) => 1), 3];
      chartOptionsArea.colors = [...this.issuesByProject.map((v, i) => colorArray[i % colorArray.length]), '#ff1100'];
      chartOptionsArea.yaxis.max = Math.round(this.plannableUsersLoad * 1.2); // CHART  HEIGHT
      return chartOptionsArea;
    },
    ganttIssues() {

      let issues = this.issues.filter((i) => {
        return (i.type === 'Epic' || i.jira_issue_parent_id === null || ['PPP'].includes(i.project.key))
          && (i.gantt_from && i.gantt_to)
          && (moment(i.gantt_to).isAfter(moment()) && moment(i.gantt_from).isBefore(this.toDate))
          && (!i.labels.find((l) => l.label === 'ignore-progress'));
      }).map((i) => {
        i.timespent /= 3600;
        i.actual_timespent /= 3600;
        i.timeestimate /= 3600;
        i.timeoriginalestimate /= 3600;
        return i;
      }).map((i) => {
        // If task state is done set gant progress to 100%
        if (i.status && ["Done", "Dev is done", "Closed", "Ready to Accept", "Canceled", "Accepted by client"].includes(i.status.name)) i.gantt_progress = 100;
        const minPercentTrack = 5;
        const shouldHaveDone = (Math.max(1 * i.gantt_progress, minPercentTrack) / 100) * i.timeoriginalestimate;
        i.noprogress = !!i.labels.find((l) => l.label === 'noprogress');
        i.eac = Math.round((i.gantt_progress < minPercentTrack || i.actual_timespent < 1)
          ? (1 * i.timeoriginalestimate + ((i.actual_timespent < shouldHaveDone) ? 0 : 1 * i.actual_timespent))
          : (i.actual_timespent === 0)
            ? 1 * i.timeoriginalestimate
            : (i.actual_timespent / i.gantt_progress) * 100);
        i.etc = Math.max(0, Math.round(i.eac - i.actual_timespent));

        i.gantt_from = moment(i.gantt_from);
        i.gantt_to = moment(i.gantt_to);
        i.isActive = i.gantt_from.isBefore(moment()) && i.gantt_to.endOf('week').isAfter(moment());
        i.isExpired = i.gantt_to.isBefore(moment());
        i.weeks_remaining = i.gantt_to.startOf('week').add(1, 'weeks').diff(moment.max(moment(i.gantt_from), moment()).startOf('week'), 'days') / 7;
        i.avgLoad = (i.weeks_remaining <= 0 && i.etc > 0) ? -1 : Math.round(((i.etc / i.weeks_remaining) / 40) * 10) / 10 || 0;

        return i;
      });

      // EAC,ETC sum for tasks with progress tracked (tasks with label noprgress are filtered out)
      const [eacTotal, etcTotal] = issues.filter(i => !i.noprogress).reduce(([eacTotal, etcTotal], i) => {
        return [eacTotal + 1 * i.eac, etcTotal + 1 * i.etc];
      }, [0, 0]);
      let totalDonePercent = Math.round((eacTotal - etcTotal) / eacTotal * 1000) / 10;

      issues = issues.map((i) => {
        // For no-progress tasks set progress  = totalDonePercent
        if (i.noprogress) {
          i.gantt_progress = totalDonePercent;
          i.eac = i.gantt_progress > 0 ? Math.round((i.actual_timespent / i.gantt_progress) * 100) : i.timeoriginalestimate;
          i.etc = Math.max(0, Math.round(i.eac - Math.round(i.actual_timespent)));
        }

        i.isActive = i.gantt_from.isBefore(moment()) && i.gantt_to.endOf('week').isAfter(moment());
        i.isExpired = i.gantt_to.isBefore(moment());
        i.weeks_remaining = i.gantt_to.startOf('week').add(1, 'weeks').diff(moment.max(moment(i.gantt_from), moment()).startOf('week'), 'days') / 7;
        i.avgLoad = (i.weeks_remaining <= 0 && i.etc > 0) ? -1 : Math.round(((i.etc / i.weeks_remaining) / 40) * 10) / 10 || 0;

        return i;
      });

      return issues;
    },

    plannableUsersEmails() {
      return this.plannableUsers.map((pu) => pu.email);
    },
    plannableUsersLoad() {
      return Math.round(this.plannableUsers.reduce((sum, pu) => { return sum + Number(pu.workload); }, 0) * 10) / 10;
    },

    chartHeight() {
      return `${this.ganttIssues.length * 18 + 50}px`;
    },
    maxDate() { return moment.max([...this.ganttIssues.map((e) => e.gantt_to), ...this.plannedWork.map((e) => e.datem)]); },
    firstDate() { return moment().startOf('week'); },
    toDate() { return moment(this.firstDate).add(4 * this.monthsAhead, 'weeks'); },
    lastDate() { return moment.min(moment(this.maxDate).startOf('week').add(1, 'weeks'), this.toDate); },
    weeks() {
      const s = moment(this.firstDate);
      // Last planned week no more than 24 months ahead
      const e = moment(this.lastDate);
      const weeks = [];
      for (let m = s; m.isBefore(e); m.add(1, 'weeks')) {
        weeks.push(moment(m)); // console.log(m.format('YYYY-MM-DD'));
      }
      return weeks;
    },

    // allso add plans
    issuesByProject() {
      const issuesByProject = this.ganttIssues.reduce((projects, i) => {
        let curProjectKey = i.project.key;
        if (this.groupActive) curProjectKey = (['PP', 'PPP'].includes(curProjectKey) ? 'Sales' : 'Active');
        const project = projects.find((p) => p.key === curProjectKey) || { key: curProjectKey, issues: [], plannedWork: [] };

        if (!project.added) projects.push(project);
        project.added = true;
        project.issues.push(i);
        return projects;
      }, []);
      if (!this.addPlannedWork) return issuesByProject;
      return this.plannedWork.reduce((projects, i) => {
        let curProjectKey = i.key;
        if (this.groupActive) curProjectKey = (['PP', 'PPP'].includes(curProjectKey) ? 'Sales' : 'Active');
        const project = projects.find((p) => p.key === curProjectKey) || { key: curProjectKey, issues: [], plannedWork: [] };
        if (!project.added) projects.push(project);
        project.added = true;
        project.plannedWork.push(i);
        return projects;
      }, issuesByProject);
      // .filter((p)=>p.key==="TEX") // for development limit testable projects
    },

    weekLoad() {
      return [
        ...this.issuesByProject
          .map((p) => {
            return {
              name: p.key,
              type: 'area',
              data: this.weeks.map((w) => {
                const w2 = moment(w).add(7, 'days');
                const hoursLoadInWeek = p.issues.reduce((hours, i) => {
                  // return hours + (w.isBefore(i.gantt_to) && w2.isAfter(i.gantt_from) ? i.etc / i.weeks_remaining : 0);
                  return hours + (
                    (w.isBefore(i.gantt_to) && w2.isAfter(i.gantt_from) && i.weeks_remaining > 0)
                      ? i.etc / i.weeks_remaining
                      : 0
                  );
                }, 0);
                const addPlannedHours = p.plannedWork.reduce((hours, i) => {
                  return hours + (w.isBefore(i.datem) && w2.isAfter(i.datem) ? i.hours : 0);
                }, 0);
                // const addPlannedHours = 0;

                return {
                  x: w.valueOf(),
                  y: Math.round((hoursLoadInWeek + addPlannedHours) / 40 * 10) / 10,
                  // issues: p.issues,
                };
              })
            };
          }),
        {
          name: 'Resources',
          type: 'line',
          data: this.weeks.map((w) => {
            const w2 = moment(w).add(7, 'days');
            const vacationLoadInWeek = (!this.withVacationsValue) ? 0 : this.vacations.reduce((hours, i) => {
              if (!(w.isSameOrBefore(i.endM, 'week') && w2.isAfter(i.startM))) return hours; // vacation does not overlap with week

              const vacationStartInWeek = moment.max(moment(w).add(1, 'days'), i.startM);
              const vacationEndInWeek = moment.min(moment(w).add(5, 'days'), moment(i.endM)); // TODO hack correct workdays
              const user = this.plannableUsers.find((u) => u.email === i.work_email);

              return hours + (user ? Number(user.workload) : 0) * ((vacationEndInWeek.diff(vacationStartInWeek, 'days') + 1) / 5);
            }, 0);
            return {
              x: w.valueOf(),
              y: this.plannableUsersLoad - vacationLoadInWeek,
              // wl: vacationLoadInWeek
              // issues: p.issues,
            };
          })
        }
      ];
    },

  },
  watch: {
    monthsAhead() {
      this.getPlannedWork();
    },
  },
  methods: {
    getData() {
      Promise.all([
        Services.dash.allProjectIssues(),
        Services.dash.vacations(),
        Services.dash.planableUsers(),
        // planableInternalUsers
        this.getPlannedWork(),
      ]).then(([issuesResp, vacationsResp, plannableUsersResp, plannedWork]) => {
        // console.log(issuesResp.data, vacationsResp.data);
        this.issues = issuesResp.data;
        this.plannableUsers = plannableUsersResp.data;
        this.vacations = vacationsResp.data.map((v) => {
          return {
            ...v,
            startM: moment(v.start),
            endM: moment(v.end), // end is inclusive
          };
        }).filter((v) => this.plannableUsersEmails.includes(v.work_email))
          .filter((v) => v.type === 'Vacation');

        this.spinners.contentIsLoading = false;
      });
    },
    getPlannedWork() {
      return new Promise((resolve, reject) => {
        Services.dash.plannedWork({ from_date: this.firstDate.format('YYYY-MM-DD'), to_date: this.toDate.format('YYYY-MM-DD') })
          .then(({ data }) => {
            this.plannedWork = data.plans.map((d) => {
              // console.log(moment(d.date).format('YYYY-MM-DD'));
              return { ...d, hours: Number(d.hours), datem: moment(d.date) };
            });
            resolve(data);
          }).catch(reject);
      });
    }

  }
};
</script>

<style>
ul.tooltipgantt {
  list-style-type: none;
  padding: 1em;
  margin: 0;
}

.vars-chart,
.vars-chart legend {
  font-size: 14px;
}
</style>
